export const teleportOpenGuard = {
  suppressHideClose: false,
};

const TOGGLE_DEBOUNCE_MS = 200;
let lastTeleportOpenAt = 0;

export const shouldDebounceTeleportOpen = (): boolean => {
  const now = Date.now();
  if (now - lastTeleportOpenAt < TOGGLE_DEBOUNCE_MS) {
    return true;
  }

  lastTeleportOpenAt = now;
  return false;
};
